class Bank {
  constructor() {
    this.iban = '' // PL ## #### #### #### #### #### ####
    this.swift = '' // ########
    this.name = ''
    this.accountOwner = ''
    this.isForeign = 0
  }
}

export { Bank }
